<template>
	<modal width="40" :show-modal="showModal" @close-modal="$emit('close-modal')" :styleContent="{ minWidth: '400px' }"
		:showTitle="false" :showCancleBtn="true" :showFooter="false">
		<div class="w-full">
			<div class="flex items-center gap-2 mb-4">
				<img width="20" src="../../../../../assets/images/icons/back-icon.svg" @click="goBack">
				<div>|</div>
				<h4 class="text-[#10233E] font-semibold text-[20px]"> Dispatch </h4>
			</div>
			<div class="flex justify-between header-wrap">
				<p class="flex-1">Consolidation Count : <b>{{ dispatchSummary?.consolidationCount }}</b></p>
				<p class="flex-1">Shipments Count : <b>{{ dispatchSummary?.shipmentCount }}</b></p>
				<p class="flex-1">Item Count: <b>{{ dispatchSummary?.totalItems }}</b> <b>({{
					dispatchSummary?.totalWeight }})</b></p>
			</div>

			<div v-for="(doc, index) in dispatchSummary?.selectedConsolidations" :key="index">
				<div class="proof-header" @click="togglePOD">
					<div class="flex-1">
						<h3 class="text-[#383F51] text-[14px] font-semibold"><span>{{ doc.originName }}</span> to
							<span>{{
								doc.destinationName }}</span></h3>
					</div>

					<p class="text-[#383F51] text-[12px] font-normal flex-1 text-center">{{ doc.shipments.length }}
						shipment</p>
					<p class="text-[#10233E] text-[12px] font-normal flex-1 text-center">{{ doc.shipments.length }}
						items</p>


					<!-- Rotating Arrow -->
					<span class="arrow" :class="{ open: isPODOpen }">
						˅
					</span>
				</div>

				<div v-if="isPODOpen">
					<div class="table-row pl-6" v-for="(bod, index) in doc.shipments" :key="index">
						<div>
							<h3 class="text-[#383F51] text-[14px] font-semibold mb-2">{{ bod?.location?.contactName }}
							</h3>
							<h3 class="text-[#383F51] text-[12px] font-normal">{{ bod?.location?.mobile }}</h3>
						</div>
						<p class="text-[#383F51] text-[12px] font-normal text-center">{{ bod?.location?.address?.address
						}}</p>
						<p class="text-[#10233E] text-[12px] font-normal text-center">{{
							bod?.shipping?.packagees?.length }} item</p>
						<p></p>
					</div>
				</div>
				<div class="mt-2">
					<h3 class="text-[#10233E] text-[16px] font-normal mb-2">Route</h3>
					<p class="text-[#383F51] text-[14px] font-normal rvcdp">{{ dispatchSummary?.routeText }}</p>
				</div>

				<div class="mt-2">
					<h3 class="text-[#10233E] text-[16px] font-normal mb-2">Vehicle/ Carrying Capacity</h3>
					<p class="text-[#383F51] text-[14px] font-normal rvcdp">{{ dispatchSummary?.fleetInfo?.capacity }}
					</p>
				</div>

				<div class="mt-2">
					<h3 class="text-[#10233E] text-[16px] font-normal mb-2">Driver</h3>
					<p class="text-[#383F51] text-[14px] font-normal rvcdp">{{ dispatchSummary?.fleetInfo?.driver ||
						"N/A" }}</p>
				</div>

				<div class="mt-2">
					<h3 class="text-[#10233E] text-[16px] font-normal mb-2">Plate Number</h3>
					<p class="text-[#383F51] text-[14px] font-normal rvcdp">{{ dispatchSummary?.fleetInfo?.plateNumber
						}}</p>
				</div>

			</div>

			<div class="button_wrapper">
				<button @click="$emit('close-modal')">Cancel</button>
				<base-button text="Continue Dispatch" :loading="loading" @click="createLongHaulDispatch" />
			</div>
		</div>
	</modal>
</template>

<script>
import { userId } from "@/services/apiConfig.js"
export default {

	props: {
		selecetedActionShipment: {},
		showModal: {
			type: Boolean,
			required: true,
			default: false,
		},
		selcetdDispatchDetail: {
			type: Array,
			required: false,
			default: null
		},
		selecetedDispatch: {
			type: Array,
			required: false,
			default: null
		},
		fleetId: {
			type: String,
			required: false,
			default: ""
		},
		dispatchSummary: {
			type: Object,
			required: false,
			default: null
		}
	},
	data() {
		return {
			isPODOpen: false,
			loading: false
		}
	},
	computed: {
		currentLocation() {
			return this.$store.getters.currentLocation;
		},

	},

	methods: {
		togglePOD() {
			this.isPODOpen = !this.isPODOpen;
		},
		closeModal() {
			this.$emit("close-modal");
		},
		goBack() {
			this.$emit("go-back");
			this.closeModal() // Close the POD section when going back
		},

		async createLongHaulDispatch() {
			this.loading = true;

			try {
				const payload = {
					consolidationIds: this.selecetedDispatch,
					fleetId: this.fleetId,
					userId: userId(),
					terminalId: this.currentLocation?.locationId,
				};

				const response = await this.$_newCreateDispatch(payload);

				if (response?.data?.success) {
					const responseData = response.data;

					if (!responseData) {
						return;
					}

					this.generateToast(
						"Long Haul Dispatch created successfully!",
						"success"
					);


					this.$router.push({ name: "Dispatch" });
				}
			} catch (error) {
				this.handleError(error);
				this.updatingUser = false;
			} finally {
				this.loading = false;
			}
		},
	}

};

</script>

<style scoped>
.proof-header {
	display: flex;
	justify-content: space-between;
	padding-top: 15px;
	padding-bottom: 15px;
	cursor: pointer;
	font-weight: bold;
}

/* Arrow rotation */
.arrow {
	display: inline-block;
	transition: transform 0.3s ease;
}

.arrow.open {
	transform: rotate(180deg);
}


.header-wrap>p {
	text-align: center;
	font-weight: 400;
	font-size: 14px;
}

.table-row {
	background: #7A90A71A;
	border-radius: 15px;
	display: flex;
	justify-content: space-between;
	padding-top: 10px;
	padding-bottom: 10px;
	/* padding-left: 10px; */
}

.button_wrapper {
	@apply mt-7 flex justify-end gap-5
}

.rvcdp {
	background: #EBF2FA;
	padding: 10px 0 10px 10px;
}
</style>